export enum LevelOfService {
    DiscountBrokerage = 0,
    FullServiceBrokerage = 1,
    StrategicFinancialAdvisoryService = 2,
}

export const LevelsOfService = [
    {
        id: LevelOfService.DiscountBrokerage,
        name: 'Discount Brokerage',
        shortName: 'DB',
    },
    {
        id: LevelOfService.FullServiceBrokerage,
        name: 'Full Service Brokerage',
        shortName: 'FSB',
    },
    {
        id: LevelOfService.StrategicFinancialAdvisoryService,
        name: 'Strategic Financial Advisory Service',
        shortName: 'SFAS',
    },
];

export const LevelOfServiceOptions = {
    [LevelOfService.DiscountBrokerage]: 'Discount Brokerage',
    [LevelOfService.FullServiceBrokerage]: 'Full Service Brokerage',
    [LevelOfService.StrategicFinancialAdvisoryService]: 'Strategic Financial Advisory Service',
}
